/* eslint-disable import/prefer-default-export */
import FlatPickrLocales from 'flatpickr/dist/l10n/fr'
import { useI18n } from 'vue-i18n'

const flatPickrLocales = FlatPickrLocales
Object.keys(flatPickrLocales).forEach(key => {
  flatPickrLocales[key].firstDayOfWeek = 1
})

// MFC2-681 NOT OK 22 — hors mode ancre, le calendrier est pose dans le corps du document aux
// coordonnees du champ, calculees a l'ouverture. Il ne suit alors pas le defilement interne du
// volet qui porte le champ, et s'en trouve decale des le premier glissement. En mode ancre il est
// place dans le volet, a cote de son champ, et le suit. Reserve aux ecrans etroits : sur un grand
// ecran le comportement actuel convient et le mode ancre se ferait rogner par les tableaux a
// defilement horizontal.
const estEcranEtroit = () => typeof window !== 'undefined' && window.matchMedia('(max-width: 767.98px)').matches

// MFC2-681 NOT OK 22 — en mode ancre, le calendrier n'est plus pose dans le corps du document mais
// dans un bloc insere a la place du champ : il se retrouve donc a l'interieur du formulaire qui
// porte ce champ. Or les champs d'heure, de minute et de seconde du module sont des champs
// numeriques, dont le pas vaut cinq pour les minutes. Une minute hors multiple de cinq y est alors
// une valeur invalide pour le navigateur, qui refuse en silence la soumission du formulaire : le
// bouton d'enregistrement ne faisait plus rien des qu'une minute comme 14:14 etait saisie ou
// simplement affichee. Le pas est donc ramene a une minute pour ces champs, ce qui rend toute
// minute valide et fait avancer les fleches du module minute par minute, le pas etant lu sur
// l'attribut. Hors mode ancre le calendrier est dans le corps du document, hors du formulaire :
// rien a corriger, le pas du module est conserve.
const ajusterLePasDesMinutes = instance => {
  if (!instance?.config?.static) return

  const champs = [instance.hourElement, instance.minuteElement, instance.secondElement].filter(Boolean)
  champs.forEach(element => element.setAttribute('step', '1'))
}

// MFC2-681 NOT OK 33 — un calendrier ancre recouvre les commandes du volet. Tant qu'il est ouvert,
// le corps du document porte la marque qui les annonce inactives. Le compte des calendriers
// ouverts evite qu'un volet a deux dates — un hangar — retire la marque en fermant le premier
// alors que le second vient de s'ouvrir.
let calendriersAncresOuverts = 0

export const marquerCalendrierAncre = (instance, ouvert, racine = typeof document !== 'undefined' ? document : null) => {
  if (!racine?.body || !instance?.config?.static) return

  calendriersAncresOuverts = Math.max(0, calendriersAncresOuverts + (ouvert ? 1 : -1))
  racine.body.classList.toggle('calendrier-ancre-ouvert', calendriersAncresOuverts > 0)
}

// MFC2-681 NOT OK 33 — le calendrier ancre se superpose aux commandes du volet : les boutons BACK,
// CANCEL et INSERER passent sous lui. Or le module se ferme sur l'appui, et le relachement produit
// ensuite un clic qui atteint le bouton reste dessous : un doigt pose au bord du calendrier fermait
// le volet et faisait perdre la saisie. Le geste qui ferme le calendrier ne doit rien faire d'autre
// que le fermer, donc le clic qu'il produit est avale une fois.
//
// Le garde ne s'arme que lorsqu'un calendrier ancre est ouvert, c'est-a-dire sur un ecran etroit :
// hors mode ancre le calendrier est pose dans le corps du document, il ne recouvre pas le
// formulaire, et rien n'est intercepte. Il se desarme sur le clic qu'il avale et, a defaut de clic
// — un defilement, par exemple —, peu apres la fin du geste : le delai part du relachement et non
// de l'appui, car un doigt pose longtemps au bord du calendrier est precisement le geste decrit.
export const installerLeGardeDuClicDeFermeture = (racine = typeof document !== 'undefined' ? document : null) => {
  if (!racine || racine.__gardeCalendrierAncre) return
  racine.__gardeCalendrierAncre = true

  let minuteur = null

  const desarmer = () => {
    racine.removeEventListener('click', avalerLeClic, true)
    if (minuteur) clearTimeout(minuteur)
  }

  function avalerLeClic(evenement) {
    evenement.preventDefault()
    evenement.stopPropagation()
    desarmer()
  }

  const surRelachement = () => {
    racine.removeEventListener('mouseup', surRelachement, true)
    racine.removeEventListener('touchend', surRelachement, true)
    if (minuteur) clearTimeout(minuteur)
    minuteur = setTimeout(desarmer, 400)
  }

  const surAppui = evenement => {
    const calendrier = racine.querySelector('.flatpickr-calendar.static.open')
    if (!calendrier) return

    // Le bloc du module porte le champ et son calendrier : un appui sur l'un ou sur l'autre
    // appartient a la saisie, il n'y a rien a avaler.
    const zone = (calendrier.closest && calendrier.closest('.flatpickr-wrapper')) || calendrier
    if (zone.contains(evenement.target)) return

    desarmer()
    racine.addEventListener('click', avalerLeClic, true)
    racine.addEventListener('mouseup', surRelachement, true)
    racine.addEventListener('touchend', surRelachement, true)
  }

  racine.addEventListener('mousedown', surAppui, true)
  racine.addEventListener('touchstart', surAppui, true)
}

export const useFlatpickr = () => {
  installerLeGardeDuClicDeFermeture()

  const { locale } = useI18n()
  const config = {
    locale: flatPickrLocales[locale.value],

    // MFC2-681 NOT OK 22 — le pas des minutes reste celui du module, cinq, sauf en mode ancre
    // (voir plus haut). Une minute hors multiple de cinq se tape au clavier dans le champ des
    // minutes du calendrier : c'est pour cela que le clavier doit s'y deplier, y compris sur un
    // appareil tactile ou il est le seul moyen de saisie.
    static: estEcranEtroit(),

    // Permet d'avoir la date affichée en UTC
    onReady: (selectedDates, dateStr, instance) => {
      if (selectedDates[0]) {
        instance.setDate(new Date(selectedDates[0].toISOString()), false)
      }
      ajusterLePasDesMinutes(instance)
    },
  }

  return { config }
}
